import Markdown from 'markdown-to-jsx'
import PropTypes from 'prop-types'

import { handleMethodsClick } from './helpers'
import * as styles from './styles'

const InputWarning = ({ warning, ...props }) => {
  return (
    <div css={styles.container}>
      <span>
        <Markdown
          options={{
            overrides: {
              a: {
                component: 'button',
                props: {
                  onClick: () => {
                    handleMethodsClick(props)
                  },
                  style: styles.button
                }
              }
            }
          }}
        >
          {warning}
        </Markdown>
      </span>
    </div>
  )
}

InputWarning.defaultProps = {
  warning: ''
}

InputWarning.propTypes = {
  warning: PropTypes.string
}

export default InputWarning
